import React from 'react';
// material-ui
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, ListItem, ListItemIcon, ListItemText, MenuItem, Radio, RadioGroup, Select, Typography } from '@mui/material';
import { SyncAlt, Delete, } from '@mui/icons-material';
import { FileCopyOutlined } from '@mui/icons-material';
// component
import Card from './Card'
import TableComponent from '../../component/table/table';
import _ from 'lodash';
// css
import './scss/second-menu-detail.scss'
import DialogComponent from '../../component/dialog/dialog.component';
import MenuListComponent, { MenuListItem } from './menu-list/menu-list-component';
import i18n from '../../i18n';
import BASE_CHECK_TYPE from '../../constants/regular.constant';
import MenuDishComponent from './menu-dish.component';
import CommonInput from '../../component/form/common-input.component';
import { Condiments, FirstMenu, ItemUnit, ITEM_TYPE, MenuDish, SecondMenu, TaxGroup } from '../../models';
import { SwitchComponent } from './dish-group-detail';
import GlobalNotification from '../../component/common/snackbar';
import setLoading from '../../component/linear-determinate';
import MuliSettingDishDialog from './multi-setting-dialog.component';
import { apiManage_rbp } from '../../request';
import { MUIDataTableColumn, MUIDataTableColumnDef, } from 'mui-datatables';
import ButtonComponent from '../../component/button/button.component';

enum DISH_ACTION_TITLE {
    'COPY_DISH' = 'menu_and_dishes_page_copy_dishes',
    'TRANSFER_DISH' = 'menu_and_dishes_page_transfer_dishes',
}
export default class SecondMenuDetail extends React.Component<Props, State> {
    public tableRef: React.RefObject<any> = React.createRef()
    public dialogRef: React.RefObject<any> = React.createRef();

    public state: State = {
        // 二级菜单详情
        detail: _.cloneDeep(this.props.detail) || {},
        // 是否显示菜单列表对话框
        isShowMenuListDialog: false,
        // 当前选中的item
        rowsSelected: [],
        // 当前选中的菜品
        dishSelected: [],
        // 是否显示确认对话框
        isShowConfirmDialog: false,
        // 选中的二级菜单id
        checkedSecondMenuIds: [],
        // 当前选中的二级菜单
        checkedSecondMenus: [],
        // 是否受轮次限制
        isJoiningGlobalLimit: false,
        // 当前菜品详情
        menuDishData: undefined,
        // 是否显示菜品详情
        isShowMenuDishData: false,
        // 菜品操作标题
        actionTitle: 'menu_and_dishes_page_copy_dishes' as DISH_ACTION_TITLE.COPY_DISH,
        // 批量设置数组
        multiSettingArr: [
            {
                label: i18n.t('menu_and_dishes_page_dish_type'),
                key: 'item_type',
                value: 0,
                type: 'radio',
                items: [
                    { label: i18n.t('menu_and_dishes_page_normal_dishes'), value: 0 },
                    { label: i18n.t('menu_and_dishes_page_dish_with_current_price'), value: 2 },
                    { label: i18n.t('menu_and_dishes_page_set_meal'), value: 3 },
                    { label: i18n.t('menu_and_dishes_page_custom_dish'), value: 4 },
                    { label: i18n.t('menu_and_dishes_page_text'), value: 5 },
                ],
                checked: false,
            },
            {
                label: i18n.t('menu_and_dishes_page_print_class'),
                key: 'print_class',
                value: -1,
                type: 'select',
                items: this.props.printGroup?.map((item) => ({
                    label: item.print_class_name || '',
                    value: item.print_class_id || -1,
                })),
                checked: false,
            },
            {
                label: i18n.t('tax_group_page_label'),
                key: 'tax_group',
                value: -1,
                type: 'select',
                items: this.props.taxGroup.map((item) => ({
                    label: item.tax_group_name || '',
                    value: item.tax_group_id || -1,
                })),
                checked: false,
            },
            {
                label: i18n.t('menu_and_dishes_page_form_main_type'),
                key: 'major_group',
                value: -1,
                type: 'select',
                items: this.props.majorGroup.map(item => ({
                    label: item.major_group_name,
                    value: item.major_group_id || -1
                })),
                checked: false,
            },
            {
                label: i18n.t('menu_and_dishes_page_form_sub_type'),
                key: 'family_group',
                value: -1,
                type: 'select',
                items: this.props.mergetypes.map(item => ({
                    label: item.family_group_name,
                    value: item.family_group_id || -1
                })),
                checked: false,
            },
            {
                key: 'class_id',
                label: i18n.t('menu_and_dishes_page_menu_dish_has_discount'),
                type: 'select',
                checked: false,
                value: 6,
                items: [
                    { label: i18n.t('menu_and_dishes_page_has_discount'), value: 6 },
                    { label: i18n.t('menu_and_dishes_page_has_not_discount'), value: 3 }
                ],
            },
            {
                key: 'rule_lnr_limit_enable',
                label: i18n.t('menu_and_dishes_page_continue_to_add'),
                type: 'select',
                checked: false,
                value: 0,
                items: [
                    { label: i18n.t('google_text_no'), value: 0 },
                    { label: i18n.t('google_text_yes'), value: 1 }
                ],
            },
            {
                key: 'rules_ignore_the_display',
                label: i18n.t('menu_and_dishes_page_dish_edition_ignore_turn_rule'),
                type: 'select',
                checked: false,
                value: 0,
                items: [
                    { label: i18n.t('google_text_no'), value: 0 },
                    { label: i18n.t('google_text_yes'), value: 1 }
                ],
            },
        ],
        // 是否显示批量设置弹窗
        isShowMultiSettingDialog: false,
        // 表格每页行数
        rowsPerPage: 20,
        // 当前页
        currPage: 0,
        // 菜品图片
        avatarUrl: '',
    }

    // 存储当前列是否可见
    public viewColumns = {
        item_id: false,
        item_name1: true,
        item_name2: false,
        price_1: true,
        takeout_price_1: true,
        item_type: true,
        rule_lnr_max_num: true,
        print_class: true,
        major_group: false,
        family_group: false,
        action: true,
        nlu: true
    }

    // 存储当前table的状态
    public currentTableState: any = null

    constructor(props: Props) {
        super(props)

        this.handleMenuListDialogShow = this.handleMenuListDialogShow.bind(this)
        this.handleTableToolbarSelectRender = this.handleTableToolbarSelectRender.bind(this)
        this.renderMenuListDialog = this.renderMenuListDialog.bind(this)
        this.onSave = _.debounce(this.onSave, 500, {
            leading: true,
            trailing: false
        }).bind(this) as any;
    }


    // *********************
    // Life Cycle Function
    // *********************

    componentDidUpdate(prevProps: Props): void {
        if (JSON.stringify(prevProps.detail) !== JSON.stringify(this.props.detail)) {
            this.setState({
                detail: this.props.detail,
                isJoiningGlobalLimit: !!this.props.detail.not_joining_global_limit
            });
        }
    }

    // *********************
    // Default Function
    // *********************

    /**
     * 选中项，表格头部工具栏显示
     * @returns
     */
    public handleTableToolbarSelectRender(
        selectedRows: { data: Array<{ index: number; dataIndex: number }>; lookup: { [key: number]: boolean } }
    ): React.ReactNode {
        // 菜品数据
        const dishesData = _.cloneDeep(this.props.detail.menu_item ?? [])
        const dishSelected = selectedRows.data.map((item) => (dishesData[item.dataIndex]))
        // view
        return (
            <>
                <div style={{ padding: '4px 12px', }}>
                    {/* 右侧按钮组 */}
                    <ButtonComponent
                        titleText={i18n.t('menu_and_dishes_page_multi_setting_dishes')}
                        handleClick={() => {
                            // this.setState({
                            //     isShowMultiSettingDialog: true,
                            // })
                            this.dialogRef?.current?._onSetDialogFunc(true);
                        }}
                    >
                        {i18n.t('menu_and_dishes_page_multi_setting_dishes')}
                    </ButtonComponent>
                    <ButtonComponent titleText={i18n.t('menu_and_dishes_page_transfer_dishes')} handleClick={() => {
                        this.setState({
                            dishSelected
                        })
                        this.handleMenuListDialogShow(true, DISH_ACTION_TITLE.TRANSFER_DISH)
                    }}>
                        <SyncAlt />
                    </ButtonComponent>
                    <ButtonComponent
                        titleText={i18n.t('menu_and_dishes_page_copy_dishes')}
                        handleClick={() => {
                            this.setState({
                                dishSelected
                            })
                            this.handleMenuListDialogShow(true, DISH_ACTION_TITLE.COPY_DISH)
                        }}
                    >
                        <FileCopyOutlined />
                    </ButtonComponent>
                    <ButtonComponent
                        titleText={i18n.t('menu_and_dishes_page_delete_dish')}
                        handleClick={() => {
                            this.setState({
                                dishSelected
                            })
                            this.handleConfirmDialogDialogShow(true)
                        }}
                    >
                        <Delete />
                    </ButtonComponent>
                </div>
            </>
        )
    }

    /**
     * 菜单列表对话框
     * @returns
     */
    public renderMenuListDialog(): JSX.Element {
        const { menuData } = this.props
        const { isShowMenuListDialog, checkedSecondMenuIds, actionTitle } = this.state
        // 左侧菜单
        // $ 对话框内的菜单可多选，新增checkedSecondMenuIds字段
        const menu = menuData.map((item) => ({
            key: `${item.main_group_id}`,
            title: item.main_group_name ?? '',
            children: (item.menu_item_slu || []).map((subMenuItem) => ({
                key: `sub-${subMenuItem.dmi_slu_id}`,
                title: subMenuItem.dmi_slu_name ?? '',
                dataSource: subMenuItem,
                checkedSecondMenuIds,
                originId: subMenuItem.dmi_slu_id,
            })),
            dataSource: item,
        }))
        return (
            <DialogComponent
                defaultHeaderProps={{
                    title: `${i18n.t(actionTitle)}`,
                    onClose: () => {
                        this.handleMenuListDialogShow(false)
                    }
                }}
                open={isShowMenuListDialog}
                fullWidth={true}
                maxWidth={'sm'}
                scroll={'paper'}
                onClose={() => {
                    this.handleMenuListDialogShow(false)
                }}
                footer={
                    <div>
                        <Button
                            color='primary'
                            variant='outlined'
                            onClick={() => {
                                this.handleMenuListDialogShow(false)
                            }}
                        >{i18n.t('google_text_public_button_cancel')}</Button>
                        <Box marginLeft={4} display='inline-block'>
                            <Button
                                color='primary'
                                variant='contained'
                                disabled={!checkedSecondMenuIds?.length}
                                onClick={async () => {
                                    await this.onConfirm()
                                }}
                            >{i18n.t('google_text_confirm')}</Button>
                        </Box>
                    </div>}
            >
                <MenuListComponent
                    fullWidth
                    isHideContextMenu={true}
                    menu={menu}
                    isShowCheckBox={true}
                    handleClick={(menu: MenuListItem) => {
                        this.handleClick(menu)
                    }}
                    style={{ maxHeight: 'unset' }}
                />
            </DialogComponent>
        )
    }

    /**
     * 批量设置对话框
     * @returns
     */
    public renderMultiSettingDialog(): JSX.Element {
        const { isShowMultiSettingDialog, multiSettingArr } = this.state

        return (
            <DialogComponent
                className='second-menu-mul-setting-dish'
                defaultHeaderProps={{
                    title: `${i18n.t('menu_and_dishes_page_multi_setting_dishes')}`,
                    onClose: () => {
                        this.setState({
                            isShowMultiSettingDialog: false
                        })
                    }
                }}
                open={isShowMultiSettingDialog}
                fullWidth={true}
                scroll={'paper'}
                onClose={() => {
                    this.setState({
                        isShowMultiSettingDialog: false
                    })
                }}
                footer={
                    <div>
                        <Button
                            color='primary'
                            variant='outlined'
                            onClick={() => {
                                this.setState({
                                    isShowMultiSettingDialog: false
                                })
                            }}
                        >{i18n.t('google_text_public_button_cancel')}</Button>
                        <Box marginLeft={4} display='inline-block'>
                            <Button
                                color='primary'
                                variant='contained'
                                onClick={() => {
                                    this.onMultiSetConfirm()
                                }}
                            >{i18n.t('google_text_confirm')}</Button>
                        </Box>
                    </div>}
            >
                <Grid container spacing={2}>
                    {
                        multiSettingArr.map((item, index) => {
                            return (
                                <Grid key={index} item xs={12}>
                                    <ListItem>
                                        <ListItemIcon>
                                            <Checkbox
                                                edge='start'
                                                color='primary'
                                                checked={item.checked}
                                                onClick={() => this.onMultiCheck(item)}
                                                tabIndex={-1}
                                                disableRipple
                                            />
                                        </ListItemIcon>
                                        <Typography>{item.label}</Typography>
                                        {item.type === 'radio' &&
                                            <FormControl component='fieldset' className={'basic-radios'} disabled={!item.checked}>
                                                <Box display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'}>
                                                    {
                                                        (item.items || []).map((radioItem, index) => {
                                                            return (
                                                                <RadioGroup key={index} row aria-label='position' name='position' defaultValue='top' className='slecrtItem '>
                                                                    <FormControlLabel
                                                                        key={`${item.value}-${index}`}
                                                                        checked={radioItem.value === item.value}
                                                                        value={radioItem.value}
                                                                        control={<Radio color='primary' />}
                                                                        label={radioItem.label}
                                                                        onChange={(event: any) => {
                                                                            let val = event.currentTarget.value
                                                                            // 判断类型
                                                                            const type = typeof (radioItem.value);
                                                                            if (type === 'string') {
                                                                                val = String(val);
                                                                            }
                                                                            if (type === 'number') {
                                                                                val = Number(val);
                                                                            }
                                                                            this.onMultiChange(val, item.key)
                                                                        }}
                                                                    />
                                                                </RadioGroup>
                                                            )
                                                        })
                                                    }
                                                </Box>
                                            </FormControl>
                                        }
                                        {item.type === 'select' &&
                                            <Box flex={1} marginLeft={10}>
                                                <CommonInput
                                                    regularType='required'
                                                    select={true}
                                                    disabled={!item.checked}
                                                    items={item.items}
                                                    variant={'outlined'}
                                                    fullWidth
                                                    value={`${item.value}` as any}
                                                    onChange={(event: any) => {
                                                        const val = event.currentTarget.getAttribute('data-value');
                                                        this.onMultiChange(val, item.key)
                                                    }}
                                                />
                                            </Box>
                                        }
                                        {
                                            // item.type === 'upload_img' &&
                                            // <Box marginLeft={40}>
                                            //     <AvatarCard
                                            //         avatarUrl={this.state.avatarUrl}
                                            //         onChangeAvatarUrl={(url, file) => {
                                            //             this.setState({
                                            //                 avatarUrl: url,
                                            //                 avatarFile: file
                                            //             })
                                            //         }}
                                            //     />
                                            // </Box>
                                        }
                                    </ListItem>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </DialogComponent>
        )
    }

    /**
     * 批量设置checked - onClick
     * @param setItem
     */
    public onMultiCheck = (setItem: {
        label: string;
        key: string;
        value: number | string;
        type: 'select' | 'radio' | 'upload_img';
        checked: boolean;
        items?: any[];
    }) => {
        const { multiSettingArr } = this.state
        const { checked, key } = setItem
        const afterMultiSettingArr = multiSettingArr.map(n => {
            if (n.key === key) {
                n.checked = !checked
            }
            return n
        })
        this.setState({
            multiSettingArr: afterMultiSettingArr,
        })
    }

    /**
     * 批量设置 -  onChange
     */
    public onMultiChange = (val: string | number, key: string) => {
        const { multiSettingArr } = this.state
        const afterMultiSettingArr = multiSettingArr.map(n => {
            if (n.key === key) {
                n.value = val
            }
            return n
        })
        this.setState({
            multiSettingArr: afterMultiSettingArr,
        })
    }

    /**
     * 批量设置确认 confirm
     */
    public onMultiSetConfirm = async () => {
        const { multiSettingArr, avatarFile } = this.state
        const { detail } = this.props
        if (!detail.menu_item || !detail.menu_item.length) {
            GlobalNotification.error(i18n.t('menu_and_dishes_page_dish_option_null'))
            return
        }
        const _rowsSelected = _.cloneDeep(this.state.rowsSelected);
        const param: any = {}
        let needUpdate = false
        let uploadImgFlag = false;
        multiSettingArr.forEach(item => {
            if (item.checked) {
                param[item.key] = item.value
                needUpdate = true
                if (item.key === 'upload_image_file') uploadImgFlag = true;
            }
        })
        if (!needUpdate) {
            GlobalNotification.error(i18n.t('menu_and_dishes_page_please_select_modify_item'))
            return
        }
        // loading
        setLoading(true);
        this.setState({
            isShowMultiSettingDialog: false,
            // 批量设置后取消勾选状态
            rowsSelected: [],
        }, async () => {
            if (avatarFile && uploadImgFlag) {
                const dishItemIds = _rowsSelected.map(rowIndex => {
                    const itemId = (detail.menu_item as MenuDish[])[rowIndex].item_id;
                    return itemId;
                })
                const chunkArrs = _.chunk(dishItemIds, 10);
                for (let i = 0, len = chunkArrs.length; i < len; i++) {
                    await Promise.all(chunkArrs[i].map(itemId => apiManage_rbp.post_dishes_image(`${itemId},${itemId}_s`, avatarFile as File)))
                }
            }
            param.slu_id = detail.dmi_slu_id
            delete param.upload_image_file;
            const res = await apiManage_rbp.patch_dishes(_rowsSelected.map(rowIndex => ({ ...param, item_id: (detail.menu_item as MenuDish[])[rowIndex].item_id })))
            if (!_.get(res, 'error') && res.affectedRows > 0) {
                GlobalNotification.success(i18n.t('global_text_operate_success'))
                await this.props.getMenuData()
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'))
            }
            setLoading(false);
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.avatarFile = undefined;
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.avatarUrl = '';
        })
    }

    /**
     * $ new 批量设置确认 confirm
     */
    public onMultiDialogSetConfirm = async (settingParams: { [key: string]: any }, avatarFile?: File) => {
        const { detail } = this.props
        if (!detail.menu_item || !detail.menu_item.length) {
            GlobalNotification.error(i18n.t('menu_and_dishes_page_dish_option_null'))
            return
        }
        const _rowsSelected = _.cloneDeep(this.state.rowsSelected);
        if (!Object.keys(settingParams).length && !avatarFile) {
            GlobalNotification.error(i18n.t('menu_and_dishes_page_dish_option_null'))
            return
        }
        // 过敏原 其他菜品标识特殊处理
        Object.keys(settingParams).forEach(key => {
            if (['allergen', 'other_detail_info'].includes(key)) settingParams[key] = settingParams[key].reduce((pre: string, cur: string) => pre += `${cur}*`, '').slice(0, -1);
        })
        const param: any = settingParams;
        // loading
        setLoading(true);
        this.setState({
            // 批量设置后取消勾选状态
            rowsSelected: [],
        }, async () => {
            if (avatarFile) {
                _rowsSelected.map(rowIndex => {
                    const itemId = (detail.menu_item as MenuDish[])[rowIndex].item_id || -1;
                    return itemId;
                })
            }
            param.slu_id = detail.dmi_slu_id
            const res = await apiManage_rbp.patch_dishes(_rowsSelected.map(rowIndex => ({ ...param, item_id: (detail.menu_item as MenuDish[])[rowIndex].item_id })))
            if (!_.get(res, 'error') && res.affectedRows > 0) {
                GlobalNotification.success(i18n.t('global_text_operate_success'))
                await this.props.getMenuData()
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'))
            }
            setLoading(false);
        });
    }

    /**
     * 批量更改二级菜单下所有菜品轮次限制
     */
    public async onChangeSwitch() {
        const { isJoiningGlobalLimit } = this.state
        this.setState({
            isJoiningGlobalLimit: !isJoiningGlobalLimit,
        }, async () => {
            const value = this.state.isJoiningGlobalLimit ? 1 : 0;
            const dishes: MenuDish[] = _.get(this.props.detail, 'menu_item') ?? []
            // 处理需要更改的字段
            const params = dishes.map((dish: MenuDish) => {
                const obj = {
                    item_id: dish.item_id,
                    not_joining_global_limit: value
                }
                return obj
            })
            this.props.onChangeDishesTurnRule(params)

        })
    }

    /**
     * 控制菜单列表对话框显示
     * @param open
     * @param actionTitle
     */
    public handleMenuListDialogShow(open: boolean, actionTitle?: DISH_ACTION_TITLE) {
        if (actionTitle) {
            this.setState({
                actionTitle
            })
        }
        this.setState({
            isShowMenuListDialog: open,
            checkedSecondMenuIds: [],
        })
    }

    /**
     * 控制确认操作对话框显示
     * @returns
     */
    public handleConfirmDialogDialogShow(open: boolean) {
        this.setState({
            isShowConfirmDialog: open,
        })
    }

    /**
     * 确认操作对话框
     * @returns
     */
    public renderConfirmDialog(): JSX.Element {
        const { isShowConfirmDialog } = this.state

        return (
            <DialogComponent
                defaultHeaderProps={{
                    title: i18n.t('menu_and_dishes_page_delete_dish'),
                    onClose: () => {
                        this.handleConfirmDialogDialogShow(false)
                    }
                }}
                open={isShowConfirmDialog}
                fullWidth={true}
                maxWidth={'xs'}
                onClose={() => {
                    this.handleConfirmDialogDialogShow(false)
                }}
                footer={
                    <div>
                        <Button
                            color='primary'
                            variant='outlined'
                            onClick={() => {
                                this.handleConfirmDialogDialogShow(false)
                            }}
                        >{i18n.t('google_text_public_button_cancel')}</Button>
                        <Box marginLeft={4} display='inline-block'>
                            <Button
                                color='primary'
                                variant='contained'
                                onClick={() => {
                                    this.deleteDishesAction()
                                }}
                            >{i18n.t('google_text_confirm')}</Button>
                        </Box>
                    </div>}
            >
                <span>{i18n.t('dinner_table_page_whether_confirm_delete')}</span>
            </DialogComponent>
        )
    }

    /**
     * 删除菜品操作
     * @returns
     */
    public async deleteDishesAction() {
        const { dishSelected, detail } = this.state
        const dishIds = dishSelected.map((dish: MenuDish) => {
            return {
                item_id: dish.item_id as number,
                slu_id: detail.dmi_slu_id as number,
            }
        })
        this.props.handleDeleteDishes(dishIds)

        this.setState({
            isShowConfirmDialog: false,
            dishSelected: [],
            // 删除后取消勾选状态
            rowsSelected: []
        })
    }

    /**
     * 新增菜品操作
     * @returns
     */
    public onCreate() {
        this.setState({
            isShowMenuDishData: true,
            menuDishData: {
                // 所在二级菜单id
                slu_id: this.props.detail?.dmi_slu_id
            },
        })
    }

    /**
     * 保存操作
     * @returns
     */
    public async onSave() {
        const { detail } = this.state
        const regular = BASE_CHECK_TYPE['required']?.regular;
        if (_.trim(detail.dmi_slu_name) && regular.test(detail.dmi_slu_name || '') && regular.test(String(detail.category_order_limit))) {
            this.props.onChangeSecondMenu(detail)
        }
    }

    /**
     * 点击菜单
     * @param menuData
     * @param index
     */
    public handleClick(menuData: MenuListItem) {
        // 二级菜单
        if (!menuData.children) {
            this.handleCheckBoxChange(menuData)
        }
    }

    /**
     * checkBox控制事件 （仅针对二级菜单）
     * @param menu
     */
    public handleCheckBoxChange(menu: MenuListItem) {
        // eslint-disable-next-line prefer-const
        let { checkedSecondMenuIds, actionTitle, checkedSecondMenus } = this.state
        const menuId = _.get(menu, 'dataSource.dmi_slu_id')
        const menuData: SecondMenu = _.get(menu, 'dataSource')
        const filterIndex = checkedSecondMenuIds.findIndex((item) => {
            return item === menuId
        })
        // 复制菜品操作 （可多选）
        if (actionTitle === DISH_ACTION_TITLE.COPY_DISH) {
            if (filterIndex === -1) {
                checkedSecondMenuIds.push(menuId)
                checkedSecondMenus.push(menuData);
            } else {
                checkedSecondMenuIds.splice(filterIndex, 1)
                checkedSecondMenus.splice(filterIndex, 1)
            }
        }
        // 转移菜品操作 （单选）
        if (actionTitle === DISH_ACTION_TITLE.TRANSFER_DISH) {
            if (filterIndex === -1) {
                checkedSecondMenuIds[0] = menuId
                checkedSecondMenus = [menuData]
            } else {
                checkedSecondMenuIds.splice(filterIndex, 1)
                checkedSecondMenus = [];
            }
        }

        this.setState({
            checkedSecondMenuIds,
            checkedSecondMenus
        })
    }

    /**
     * 复制、转移菜品确认事件
     * @returns
     */
    public async onConfirm() {
        const { dishSelected, checkedSecondMenuIds, checkedSecondMenus, actionTitle } = this.state
        if (actionTitle === DISH_ACTION_TITLE.COPY_DISH) {
            // $ 复制菜品
            // 过滤选中的菜品字段(只传菜品id)
            const dishIds = dishSelected.map((dish: MenuDish) => {
                return dish.item_id
            })
            // 选中的二级菜单ids
            const secondMenuIds = _.cloneDeep(checkedSecondMenuIds)
            // 请求接口
            this.props.onChangeDishesCopy(dishIds as number[], secondMenuIds, checkedSecondMenus)
        }

        if (actionTitle === DISH_ACTION_TITLE.TRANSFER_DISH) {
            // $ 转移菜品
            // 处理传参
            const params = dishSelected.map((dish: MenuDish) => {
                const obj: MenuDish = {
                    item_id: dish.item_id,
                    slu_id: checkedSecondMenuIds[0],
                    not_joining_global_limit: checkedSecondMenus[0].not_joining_global_limit
                }
                return obj
            })
            this.props.onChangeDishesTransfer(params)
        }

        this.setState({
            isShowMenuListDialog: false,
            // 复制、转移菜品后取消勾选状态
            rowsSelected: []
        })
    }

    /**
     * 列表过滤器配置
     */
    filterOptionsDisPlay(
        filterList: string[][],
        onChange: {
            (val: string | string[], index: number, column: MUIDataTableColumn): void;
            (arg0: any, arg1: any, arg2: any): void;
        },
        index: number,
        column: MUIDataTableColumn,
        // printGroup 打印组 | major_group 主类别 | family_group 子类别
        type: 'printGroup' | 'majorGroup' | 'familyGroup'
    ) {
        let optionValues: { label: string, value: string }[] = [];
        let labelText: string = '';
        switch (type) {
            case 'printGroup':
                optionValues = this.props.printGroup?.map((item) => {
                    return {
                        label: item.print_class_name || '',
                        value: item.print_class_id || -1,
                    }
                });
                labelText = i18n.t('menu_and_dishes_page_print_class');
                break;
            case 'majorGroup':
                optionValues = this.props.majorGroup.map((item) => ({
                    label: item.major_group_name || '',
                    value: item.major_group_id || -1,
                }));
                labelText = i18n.t('menu_and_dishes_page_main_type');
                break;
            case 'familyGroup':
                optionValues = this.props.mergetypes.map((item) => ({
                    label: item.family_group_name || '',
                    value: item.family_group_id || -1,
                }));
                labelText = i18n.t('menu_and_dishes_page_sub_type');
                break;
            default:
                break;
        }
        const renderValue = (selected: unknown) => _.compact(optionValues.map((item) => {
            if ((selected as string[])?.includes(item.value)) {
                return item.label
            }
            return false
        }))?.join(',') as React.ReactNode


        return (
            <div>
                <FormLabel>{labelText}</FormLabel>
                <FormGroup style={{ overflow: 'hidden', flexWrap: 'unset' }}>
                    <Select
                        multiple
                        value={filterList[index]}
                        renderValue={renderValue}
                        onChange={(event) => {
                            filterList[index] = event.target.value as string[];
                            onChange(filterList[index], index, column);
                        }}
                    >
                        {optionValues.map((item) => (
                            <MenuItem key={item.value} value={item.value}>
                                <ListItemText primary={item.label} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormGroup>
            </div>
        )
    }

    // *********************
    // View
    // *********************

    render() {
        const { menuDishData, isShowMenuDishData, detail, rowsPerPage } = this.state
        // 税率组
        const taxGroup = this.props.taxGroup.map((item) => ({
            label: item.tax_group_name || '',
            value: item.tax_group_id || 0
        }));
        taxGroup.unshift({
            value: -1,
            label: i18n.t('menu_and_dishes_page_not_specified')
        })
        // 菜品数据
        const dishesData = _.cloneDeep(this.props.detail.menu_item ?? [])
        // 列
        const columns: MUIDataTableColumnDef[] = [
            {
                name: 'item_id',
                label: i18n.t('menu_and_dishes_page_dish_id'),
                options: {
                    filter: false,
                    display: this.viewColumns['item_id']
                }
            },
            {
                name: 'item_name1',
                label: `${i18n.t('base_setting_dish_name')}1`,
                options: {
                    filter: false,
                    display: this.viewColumns['item_name1']
                }
            },
            {
                name: 'item_name2',
                label: i18n.t('menu_and_dishes_page_dish_name2'),
                options: {
                    filter: false,
                    display: this.viewColumns['item_name2']
                }
            },
            {
                name: 'price_1',
                label: i18n.t('menu_and_dishes_page_dine_in_price'),
                options: {
                    filter: false,
                    display: this.viewColumns['price_1']
                }
            },
            {
                name: 'takeout_price_1',
                label: i18n.t('menu_and_dishes_page_takeout_price'),
                options: {
                    filter: false,
                    display: this.viewColumns['takeout_price_1']
                }
            },
            {
                name: 'print_class',
                label: i18n.t('menu_and_dishes_page_print_class'),
                options: {
                    filter: true,
                    display: this.viewColumns['print_class'],
                    customBodyRenderLite: (dataIndex: number) => {
                        return (
                            <Typography variant='subtitle1' >
                                {
                                    dishesData[dataIndex]?.print_class ?
                                        _.find(this.props.printGroup, (iitem) => iitem.print_class_id === dishesData[dataIndex]?.print_class)?.print_class_name
                                        :
                                        i18n.t('print_setting_page_none0')
                                }
                            </Typography>
                        )
                    },
                    customFilterListOptions: {
                        render: (v) => {
                            return v.map((item: string) => {
                                const label = _.find(this.props.printGroup, (iitem) => iitem.print_class_id === item)?.print_class_name
                                if (String(item) === '-1') {
                                    return `${i18n.t('menu_and_dishes_page_print_class')} : ${label}`
                                }
                                return label
                            })
                        }
                    },
                    filterType: 'custom',
                    filterOptions: {
                        logic: (prop, filterValue) => {
                            // “”，0，null 也是 “无”
                            if (filterValue.includes(-1) && !prop) {
                                return false;
                            }
                            if (filterValue.length) return !filterValue.includes(prop);
                            return false;
                        },
                        display: (filterList, onChange, index, column) =>
                            this.filterOptionsDisPlay(filterList, onChange, index, column, 'printGroup')
                    }
                }
            },
            {
                name: 'nlu',
                label: i18n.t('rwa_setting_page_mnemonic_code'),
                options: {
                    filter: false,
                    display: this.viewColumns['nlu']
                }
            },
            {
                name: 'rule_lnr_max_num',
                label: i18n.t('menu_and_dishes_page_rule_lnr_max_num'),
                options: {
                    filter: false,
                    display: this.viewColumns['rule_lnr_max_num']
                }
            },
            {
                name: 'item_type',
                label: i18n.t('menu_and_dishes_page_dish_type'),
                options: {
                    filter: false,
                    searchable: false,
                    customBodyRenderLite: (dataIndex: number) => {
                        const itemType = ITEM_TYPE.find((item) => item.value === dishesData[dataIndex].item_type);
                        return (
                            <Typography variant='subtitle1' >
                                {itemType?.label || ''}
                            </Typography>
                        )
                    },
                    display: this.viewColumns['item_type']
                }
            },
            // {
            //     name: 'not_joining_global_limit',
            //     label: '不受轮次限制',
            //     options: {
            //         download: false,
            //         searchable: false,
            //         customBodyRenderLite: (dataIndex: number, rowIndex: number) => {
            //             // 当前菜品详情数据
            //             const currentMenuDishData = dishesData[dataIndex]
            //             return (
            //                 <SwitchComponent
            //                     value={!!currentMenuDishData.not_joining_global_limit}
            //                     label=''
            //                 />
            //             )
            //         }
            //     }
            // },
            {
                name: 'major_group',
                label: i18n.t('menu_and_dishes_page_main_type'),
                options: {
                    filter: true,
                    display: this.viewColumns['major_group'],
                    customBodyRenderLite: (dataIndex: number) => {
                        return (
                            <Typography variant='subtitle1' >
                                {
                                    dishesData[dataIndex]?.major_group ?
                                        _.find(this.props.majorGroup, (iitem) => iitem.major_group_id === dishesData[dataIndex]?.major_group)?.major_group_name
                                        :
                                        i18n.t('print_setting_page_none0')
                                }
                            </Typography>
                        )
                    },
                    customFilterListOptions: {
                        render: (v) => {
                            return v.map((item: string) => {
                                const label = _.find(this.props.majorGroup, (iitem) => iitem.major_group_id === item)?.major_group_name
                                if (String(item) === '-1') {
                                    return `${i18n.t('menu_and_dishes_page_main_type')} : ${label}`
                                }
                                return label
                            })
                        }
                    },
                    filterType: 'custom',
                    filterOptions: {
                        logic: (prop, filterValue) => {
                            // “”，0，null 也是 “无”
                            if (filterValue.includes(-1) && !prop) {
                                return false;
                            }
                            if (filterValue.length) return !filterValue.includes(prop);
                            return false;
                        },
                        display: (filterList, onChange, index, column) =>
                            this.filterOptionsDisPlay(filterList, onChange, index, column, 'majorGroup')
                    }
                }
            }, {
                name: 'family_group',
                label: i18n.t('menu_and_dishes_page_sub_type'),
                options: {
                    filter: true,
                    display: this.viewColumns['family_group'],
                    customBodyRenderLite: (dataIndex: number) => {
                        return (
                            <Typography variant='subtitle1' >
                                {
                                    dishesData[dataIndex]?.family_group ?
                                        _.find(this.props.mergetypes, (iitem) => iitem.family_group_id === dishesData[dataIndex]?.family_group)?.family_group_name
                                        :
                                        i18n.t('print_setting_page_none0')
                                }
                            </Typography>
                        )
                    },
                    customFilterListOptions: {
                        render: (v) => {
                            return v.map((item: string) => {
                                const label = _.find(this.props.mergetypes, (iitem) => iitem.family_group_id === item)?.family_group_name
                                if (String(item) === '-1') {
                                    return `${i18n.t('menu_and_dishes_page_sub_type')} : ${label}`
                                }
                                return label
                            })
                        }
                    },
                    filterType: 'custom',
                    filterOptions: {
                        logic: (prop, filterValue) => {
                            // “”，0，null 也是 “无”
                            if (filterValue.includes(-1) && !prop) {
                                return false;
                            }
                            if (filterValue.length) return !filterValue.includes(prop);
                            return false;
                        },
                        display: (filterList, onChange, index, column) =>
                            this.filterOptionsDisPlay(filterList, onChange, index, column, 'familyGroup')
                    }
                }
            },
            {
                name: 'action',
                label: i18n.t('google_text_check_detail'),
                options: {
                    sort: false,
                    download: false,
                    searchable: false,
                    filter: false,
                    display: this.viewColumns['action'],
                    customBodyRenderLite: (dataIndex: number) => {
                        return (
                            <ButtonComponent action='VIEW' handleClick={() => {
                                // 当前菜品详情数据
                                const currentMenuDishData = dishesData[dataIndex]
                                this.setState({
                                    isShowMenuDishData: true,
                                    menuDishData: currentMenuDishData,
                                })
                                this.currentTableState = this.tableRef?.current.baseTableRefs?.current?.state
                            }} />
                        )
                    }
                }
            }

        ]
        return (
            <>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} lg={12}>
                        <Card
                            actionRender={(
                                <ButtonComponent
                                    action='SAVE'
                                    handleClick={() => { this.onSave() }}
                                />
                            )}
                            title={i18n.t('menu_and_dishes_page_basic_info')}
                            contentRender={(
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <CommonInput
                                            required={true}
                                            regularType='required'
                                            variant={'outlined'}
                                            fullWidth
                                            label={i18n.t('menu_and_dishes_page_secondary_menu_name')}
                                            value={`${_.get(detail, 'dmi_slu_name') ?? ''}` as any}
                                            onChange={(event: any) => {
                                                const setDetail = _.set(detail, 'dmi_slu_name', event.target.value)
                                                this.setState({
                                                    detail: setDetail,
                                                })
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <CommonInput
                                            type='number'
                                            required={true}
                                            regularType='required'
                                            variant={'outlined'}
                                            fullWidth
                                            label={i18n.t('menu_and_dishes_page_same_type_order_limit')}
                                            value={`${_.get(detail, 'category_order_limit') ?? ''}` as any}
                                            onChange={(event: any) => {
                                                let value = event.target.value
                                                if (value && Number(value) < 0) {
                                                    value = 0
                                                }
                                                else if (value) {
                                                    value = Number(Number(value).toFixed(0))
                                                }
                                                const setDetail = _.set(detail, 'category_order_limit', value)
                                                this.setState({
                                                    detail: setDetail,
                                                })
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            )}
                        />
                    </Grid>
                </Grid>
                {
                    !isShowMenuDishData ?
                        <Box marginTop='10px'>
                            <Grid container alignItems='center' style={{ marginBottom: '8px' }}>
                                <Grid item>
                                    <ButtonComponent
                                        action='ADD'
                                        handleClick={() => { this.onCreate() }}
                                    />
                                </Grid>
                                {
                                    dishesData.length > 0 &&
                                    <Grid item >
                                        <SwitchComponent
                                            value={!!this.props.detail.not_joining_global_limit}
                                            label={i18n.t('menu_and_dishes_page_batch_setup_dishes_away_round_limit')}
                                            onChange={() => {
                                                this.onChangeSwitch()
                                            }}
                                        />
                                    </Grid>
                                }
                            </Grid>
                            <TableComponent
                                ref={this.tableRef}
                                data={this.props.detail?.menu_item ?? []}
                                columns={columns}
                                search={true}
                                selectToolbarPlacement={'replace'}
                                selectableRowsHideCheckboxes={false}
                                selectableRowsHeader={true}
                                pagination={true}
                                rowsPerPage={rowsPerPage}
                                page={this.state.currPage}
                                rowsSelected={this.state.rowsSelected}
                                onRowSelectionChange={(currentRowsSelected: any[], allRowsSelected: any[], rowsSelected?: any[]) => {
                                    this.setState({
                                        rowsSelected: rowsSelected || []
                                    })
                                }}
                                onChangePage={(page: number) => {
                                    this.setState({ currPage: page })
                                }}
                                onChangeRowsPerPage={(nums: number) => {
                                    this.setState({
                                        rowsPerPage: nums,
                                    })
                                }}
                                selectableRowsOnClick={true}
                                customToolbarSelect={(
                                    selectedRows: { data: Array<{ index: number; dataIndex: number }>; lookup: { [key: number]: boolean } },
                                ): React.ReactNode => {
                                    return this.handleTableToolbarSelectRender(selectedRows);
                                }}
                                otherOption={{
                                    viewColumns: true,
                                    download: false,
                                    downloadOptions: {
                                        filename: this.props.detail.dmi_slu_name,
                                    },
                                    filter: true,
                                    onViewColumnsChange: (changedColumn: string, action: string) => {
                                        this.viewColumns[changedColumn as keyof typeof this.viewColumns] = action === 'add'
                                    }
                                }}
                            />
                        </Box>
                        :
                        <MenuDishComponent
                            menuListForSet={this.props.menuListForSet}
                            menuData={this.props.menuData
                            }
                            detail={menuDishData as MenuDish}
                            handleClickBack={() => {
                                this.setState({
                                    isShowMenuDishData: false,
                                    menuDishData: undefined,
                                }, () => {
                                    this.currentTableState && this.tableRef?.current.baseTableRefs?.current.setState({ ...this.currentTableState })
                                    this.currentTableState = null
                                })
                            }}
                            getMenuData={this.props.getMenuData}
                            updateDetail={(menuDish) => {
                                this.setState({
                                    menuDishData: menuDish
                                })
                            }}
                            taxGroup={this.props.taxGroup}
                            condimentsGroup={this.props.condimentsGroup}
                            printGroup={this.props.printGroup}
                            priceSpecList={this.props.priceSpecList}
                            majorGroup={this.props.majorGroup}
                            mergetypes={this.props.mergetypes}
                        />

                }

                {/* 菜单列表对话框 */}
                {this.renderMenuListDialog()}
                {/* 确认操作对话框 */}
                {this.renderConfirmDialog()}
                {/* 菜品批量设置对话框 */}
                {/* {this.renderMultiSettingDialog()} */}
                <MuliSettingDishDialog
                    ref={this.dialogRef}
                    taxGroup={this.props.taxGroup}
                    condimentsGroup={this.props.condimentsGroup}
                    printGroup={this.props.printGroup}
                    majorGroup={this.props.majorGroup}
                    mergetypes={this.props.mergetypes}
                    priceSpecList={this.props.priceSpecList}
                    onMultiDialogSetConfirm={this.onMultiDialogSetConfirm}
                />
            </>
        )
    }
}

// *********************
// Type
// *********************
type Props = {
    // 菜单数据（含菜品，供套餐选择菜品使用）
    menuListForSet: FirstMenu[];
    // 菜单源数据
    menuData: FirstMenu[];
    // 二级菜单详情
    detail: SecondMenu;
    // 修改二级菜单
    onChangeSecondMenu: (detail: SecondMenu) => void;
    // 批量更改二级菜单下所有菜品轮次限制
    onChangeDishesTurnRule: (dishes: MenuDish[]) => void;
    // 刷新菜单数据
    getMenuData: () => void;
    // 批量转移菜品
    onChangeDishesTransfer: (dishes: MenuDish[]) => void;
    // 批量复制菜品
    onChangeDishesCopy: (dishIds: number[], secondMenuIds: number[], secondMenus: SecondMenu[]) => void;
    // 批量删除菜品
    handleDeleteDishes: (dishIds: { item_id: number, slu_id: number }[]) => void;
    // 税率组
    taxGroup: TaxGroup[];
    // 调味品组
    condimentsGroup: Condiments[];
    // 菜品规格列表
    priceSpecList: ItemUnit[];
    // 打印组
    printGroup: any[];
    // 报表主类别
    majorGroup: any[];
    // 报表子类别
    mergetypes: any[];
}

type State = {
    // 二级菜单详情
    detail: SecondMenu;
    // 是否显示菜单列表对话框
    isShowMenuListDialog: boolean;
    // 当前选中的item
    rowsSelected: any[];
    // 当前选中的菜品
    dishSelected: MenuDish[];
    // 是否显示确认对话框
    isShowConfirmDialog: boolean;
    // 当前选中的二级菜单id
    checkedSecondMenuIds: number[];
    // 当前选中的二级菜单
    checkedSecondMenus: SecondMenu[];
    // 是否受轮次限制
    isJoiningGlobalLimit: boolean;
    // 当前菜品详情
    menuDishData: MenuDish | undefined;
    // 是否显示菜品详情
    isShowMenuDishData: boolean;
    // 菜品操作标题
    actionTitle: DISH_ACTION_TITLE;
    // 批量设置数组
    multiSettingArr: Array<{
        label: string;
        key: string;
        value: number | string;
        type: 'select' | 'radio' | 'upload_img';
        checked: boolean;
        items?: any[];
    }>
    // 是否显示批量设置弹窗
    isShowMultiSettingDialog: boolean;
    // 表格每页行数
    rowsPerPage: number;
    // 当前页
    currPage: number;
    // 菜品图片
    avatarUrl: string;
    // 菜品图片文件
    avatarFile?: File;
}

